import axios from "axios";
import initializeAxios from "../util/Axios";

class SchoolService {
  constructor() {
    initializeAxios();
  }

  async getCurrentSchool() {
    const response = await axios.get("/api/school");
    return response.data;
  }

  async getSchools(
    searchText = "",
    pageIndex = 0,
    pageSize = 10,
    registrationStatus = "all",
    membershipTier = "all"
  ) {
    const response = await axios.get("/api/schools", {
      params: {
        searchText,
        pageIndex,
        pageSize,
        registrationStatus,
        membershipTier
      }
    });

    return response.data;
  }

  async getSchoolById(id) {
    const response = await axios.get(`/api/schools/${id}`);
    return response.data;
  }

  async updateSchool(id, data) {
    const response = await axios.put(`/api/schools/${id}`, data);
    return response.data;
  }

  async approveSchool(id, data = {}) {
    const response = await axios.post(`/api/schools/${id}/approve`, data);
    return response.data;
  }

  async rejectSchool(id, reason) {
    const response = await axios.post(`/api/schools/${id}/reject`, {
      reason
    });
    return response.data;
  }
}

export default new SchoolService();
